operatorLookup =
    "^": "starts with"
    "$": "ends with"
    "*": "contains"

module.exports =
    operatorLookup: operatorLookup
